import mixpanel from 'mixpanel-browser'

const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN

/**
 * 現在のページ情報を取得する共通ヘルパー関数
 * @returns ページ情報のオブジェクト
 */
const getPageInfo = () => ({
  pathname: typeof window !== 'undefined' ? window.location.pathname : '',
  hash: typeof window !== 'undefined' ? window.location.hash : '',
})

export const initMixpanel = () => {
  if (!MIXPANEL_TOKEN) return
  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: true,
    record_sessions_percent: 100,
    record_heatmap_data: true,
  })
}

export const trackPageView = (url: string) => {
  if (!MIXPANEL_TOKEN) return

  mixpanel.track('Page View', {
    page: url,
    ...getPageInfo(),
  })
}

export const trackEvent = (
  eventName: string,
  properties?: Record<string, unknown>,
) => {
  if (!MIXPANEL_TOKEN) return

  mixpanel.track(eventName, {
    ...getPageInfo(),
    ...properties,
  })
}

export const identifyUser = (
  userId: string,
  properties?: Record<string, unknown>,
) => {
  if (!MIXPANEL_TOKEN) return

  mixpanel.identify(userId)
  if (properties) {
    mixpanel.people.set(properties)
  }
}

export { mixpanel }
